import React, { Component } from "react";
import "./Popup.scss";
import { shareFacebook, shareWhatsapp } from "../Services/Sharing";

export default class Popup extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className={`popup ${this.props.showPopup ? " active" : ""}`}>
                <div className="fade"></div>
                <div className="padding">
                    {this.props.Comp ? this.props.Comp : ""}
                    {!this.props.Comp ? 
                        <div className="container">
                        <div className="close" onClick={() => this.props.togglePopup(null)}></div>
                            <div className="headline">
                                <div className="head">
                                    יש קואליציה!
                            </div>
                                <div className="desc">
                                  כעת תוכלו לשתף את המשחק עם חברים
                            </div>
                            </div>
                            <div className="shares">
                                <div className="whatsapp" onClick={shareWhatsapp}></div>
                                <div className="facebook" onClick={shareFacebook}></div>
                            </div>
                        </div> : ""}
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx